import React from "react";
import Listv3 from "../List/ListV3";
import "../Events/Events.css";

const Events = () => {
  const eventList3 = [
    {
      photo: require("../../Assets/ClubCollab2023/taylors_dance_club.png"),
      title: "Taylor's Lakeside Dance Club",
      desc: "Unites dance enthusiasts, specialises in street dance, and showcases skills on various platforms. Groove with us!",
      link: 'https://www.instagram.com/tldanceclub/'
    },
    {
      photo: require("../../Assets/ClubCollab2023/L.I.V.E_club.png"),
      title: "Taylor’s L.I.V.E. Club",
      desc: "Spreads inspiration through a capella music. Fosters a family of singers empowering others. Discover your voice!",
      link: 'https://www.instagram.com/taylors.live.club/'
    },
    {
      photo: require("../../Assets/ClubCollab2023/taylors_art_club.png"),
      title: "Taylor’s Art Club",
      desc: "A haven for art enthusiasts, embraces diverse forms of art. Collaborating with Taylor’s Music Club for exciting events."
    },
    {
      photo: require("../../Assets/ClubCollab2023/etc_magazine_club.png"),
      title: "Etc. Magazine Club",
      desc: "Produces Taylor’s official magazine, known for buzzing campus event coverage. Join us at events and enjoy the coverage!",
      link: 'https://www.instagram.com/etctaylors/'
    },
    {
      photo: require("../../Assets/ClubCollab2023/24_festive_drum_club.png"),
      title: "Taylor’s 24 Festive Drum Club",
      desc: "Nurtures a family of passionate participants preserving the cultural heritage of 24 Festive Drums. Join our rhythmic tradition!",
      link: 'https://www.instagram.com/taylors24fd/'
    },
    {
      photo: require("../../Assets/ClubCollab2023/mixology_club.png"),
      title: "Taylor’s Mixology Club (Booze and Fuse)",
      desc: "Bartending enthusiasts sharing cocktail knowledge. Hosts parties, workshops, and bar visits. Responsible drinking and mocktails for all ages.",
      link: 'https://www.instagram.com/boozeandfuse.tu/'
    },
  ];


  return (
    <div className="pt-40 container mx-auto h-full relative event-parent">
      <div className="content-aside-container text-white" id="collaboration">
        <h3 className="mb-7  text-2xl event-list-hd title">Taylor’s Clubs Collaboration</h3>
      </div>
      <Listv3 event={eventList3} />
    </div>
  );
};

export default Events;
